import moment from 'moment';
import { InferType, object, string, number, boolean } from 'yup';

import i18n from '@components/i18n';
import { yupMultipleFiles, yupMobileNumber } from '@utils/yup';
import { PaymentMethods } from '@models/PaymentInfo';

export const formValuesSchema = object().shape({
  policyHolder: string().default('').required(i18n.t('validation:required')),
  policyHolderGender: string().default('').required(i18n.t('validation:required')),
  policyHolderDob: string().default('').required(i18n.t('validation:required')),
  policyPlanType: string().default('').required(i18n.t('validation:required')),
  policyNumber: string().default('').required(i18n.t('validation:required')),
  policyExpiryDate: string()
    .default(() => moment(new Date()).format('YYYY-MM-DDTHH:mm'))
    .required(i18n.t('validation:required')),

  mobileNumber: yupMobileNumber().default(''),
  email: string().email(i18n.t('validation:email')).required(i18n.t('validation:required')).default(''),

  paymentInfo: object({
    paymentMethod: string().default('').required(i18n.t('validation:required')),
    beneficiaryName: string().default('').required(i18n.t('validation:required')),
    bankName: string()
      .default('')
      .when('paymentMethod', {
        is: (paymentMethod: string) => paymentMethod === PaymentMethods.BankTransfer,
        then: (schema) => schema.required(i18n.t('validation:required')),
        otherwise: (schema) => schema.optional(),
      }),
    bankAccount: string()
      .default('')
      .when('paymentMethod', {
        is: (paymentMethod: string) => paymentMethod === PaymentMethods.BankTransfer,
        then: (schema) => schema.required(i18n.t('validation:required')),
        otherwise: (schema) => schema.optional(),
      }),
  }),
  accidentHappenedAt: string().default('').required(i18n.t('validation:required')),
  symptomsDescription: string().default('').optional(),
  diagnosisDescription: string().default('').optional(),
  coveredByOtherInsurance: boolean().default(false).required(i18n.t('validation:required')),
  noteOnOtherInsurance: string().default('')
    .when('coveredByOtherInsurance', {
      is: true,
      then: (schema) => schema.required(i18n.t('validation:required')),
      otherwise: (schema) => schema.optional(),
    }),
  identityDocuments: yupMultipleFiles({ required: true }),
  medicalDocuments: yupMultipleFiles({ required: true }),
  totalClaimedAmount: number()
    .default(0)
    .required(i18n.t('validation:required'))
    .positive(i18n.t('validation:positive')),
  acceptTermsAndConditions: boolean()
    .default(false)
    .test('required', i18n.t('validation:required'), (checked) => checked === true),
});

export type FormValues = InferType<typeof formValuesSchema>;
